import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsUberComponent } from './simple-icons-uber.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsUberComponent ],
    exports:      [ SimpleIconsUberComponent ],
    bootstrap:    []
})
export class SimpleIconsUberModule {}
